import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './App.css';
import {QueuePage} from "./ui/pages/QueuePage";
import * as serviceWorker from './serviceWorkerRegistration'
import {LoginPage} from "./ui/pages/LoginPage";
import {RegisterPage} from "./ui/pages/RegisterPage";
import {AuthProvider} from "./core/context/providers/AuthProvider";
import {HomePage} from "./ui/pages/HomePage";
import {PrivacyPolicyPage} from "./ui/pages/PrivacyPolicyPage";

function App() {
  return (
   <BrowserRouter>
       <AuthProvider>
           <Routes>
               <Route path='/' element={<HomePage />}/>
               <Route path='/privacypolicy' element={<PrivacyPolicyPage />}/>
               {/*<Route path='/queue' element={<QueuePage />}/>*/}
               {/*<Route path='/' element={<QueuePage />}/>*/}
           </Routes>
       </AuthProvider>
    </BrowserRouter>
  );
}

serviceWorker.register();

export default App;
